import { toVector3 } from '@utils/conversion/toVector3'
import { oneEightyDeg } from '../../store/baseValues'

export function getWidth(
  v1: [number, number] | [number, number, number],
  v2: [number, number] | [number, number, number],
) {
  return toVector3(v1).distanceTo(toVector3(v2))
}

export function getVector(v1: number[], v2: number[]) {
  return [v1[0] - v2[0], v1[1] - v2[0]]
}

export function getAngle2D(start: [number, number], end: [number, number]) {
  const firstVector = getVector(start, end)
  let angle = Math.atan2(end[1] - start[1], end[0] - start[0])
  if (angle > oneEightyDeg || angle < -oneEightyDeg) {
    angle = angle % oneEightyDeg
  }
  return {
    angle,
    vector: firstVector,
  }
}

export function degrees(radians: number) {
  return (radians * 180) / Math.PI
}

export function radians(degrees: number) {
  return (degrees * Math.PI) / 180
}
